import { IconButton } from '@components/button/iconButton';
import { Loader } from '@components/loader';
import { useBenchUsersTable } from '@components/tables/benchUsers';
import { useCheckUserPermissions } from '@hooks/checkUserPermisions';
import { BaseLayout } from '@layouts/base';
import { useList } from '@services/staff/benchUsers/list';
import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

function BenchUsers() {
  const { t } = useTranslation('app');
  const { localId } = useParams({ from: '/u/$localId/_staff/staff/bench-users/' });
  const { verifyUserPermission } = useCheckUserPermissions();
  const navigate = useNavigate();
  const { data, isPending } = useList();

  function handleSelect(id: string) {
    navigate({ to: '/u/$localId/staff/bench-users/$id/edit', params: { localId, id } }).catch(
      (err) => console.error(err),
    );
  }

  function newRedirect() {
    navigate({ to: '/u/$localId/staff/bench-users/new', params: { localId } }).catch((err) =>
      console.error(err),
    );
  }

  const { Table: BenchUsersTable } = useBenchUsersTable({
    data,
    onRowSelect: handleSelect,
  });

  if (isPending) return <Loader />;

  return (
    <BaseLayout
      title={t('pages.benchUsers.title')}
      actions={[
        verifyUserPermission('bench_users_create') && (
          <IconButton key="new" icon={<Plus size={18} />} variant="secondary" onClick={newRedirect}>
            {t('actions.addNew')}
          </IconButton>
        ),
      ]}>
      <BenchUsersTable />
    </BaseLayout>
  );
}

export const Route = createFileRoute('/u/$localId/_staff/staff/bench-users/')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['bench_users_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: BenchUsers,
});
